import { Link } from "react-router-dom";
import { CATEGORIES, projectsIn, projectPath } from "@/data/site";

export const Footer = () => (
  <footer className="bg-heritage-deep text-ivory" data-testid="site-footer">
    <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 md:px-10">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Link to="/" className="inline-flex flex-col items-center text-center" data-testid="footer-logo-link">
            <img src="/images/crest.webp" alt="Little Englishman's Bay Estate crest" className="w-60" loading="lazy" />
            <span className="mt-5 flex w-full items-center gap-3 font-caps text-[13px] tracking-[0.5em] text-ivory">
              <span className="h-px flex-1 bg-gold/60" />Little<span className="h-px flex-1 bg-gold/60" />
            </span>
            <span className="mt-1 whitespace-nowrap font-caps text-[1.7rem] leading-none tracking-[0.04em] text-ivory">Englishman's Bay</span>
            <span className="mt-2 flex w-full items-center gap-3 font-caps text-[13px] tracking-[0.5em] text-ivory">
              <span className="h-px flex-1 bg-gold/60" />Estate<span className="h-px flex-1 bg-gold/60" />
            </span>
            <span className="mt-3 font-caps text-[12px] tracking-[0.3em] text-gold">Est. 1777</span>
          </Link>
          <p className="mt-6 font-caps text-[12px] tracking-[0.3em] text-gold">Tobago, Trinidad & Tobago</p>
          <div className="mt-8 flex gap-6 text-sm">
            <Link to="/estate" className="text-ivory/80 hover:text-gold" data-testid="footer-link-estate">The Estate</Link>
            <Link to="/history" className="text-ivory/80 hover:text-gold" data-testid="footer-link-history">History of Tobago</Link>
            <Link to="/contact" className="text-ivory/80 hover:text-gold" data-testid="footer-link-contact">Contact</Link>
          </div>
        </div>
        <div className="grid gap-10 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-3">
          {CATEGORIES.map((c) => (
            <div key={c.slug}>
              <Link to={`/${c.slug}`} className="font-display text-xl text-gold-light hover:text-gold" data-testid={`footer-cat-${c.slug}`}>
                {c.title}
              </Link>
              <ul className="mt-3 space-y-1.5">
                {projectsIn(c.slug).map((p) => (
                  <li key={p.slug}>
                    <Link to={projectPath(p)} className="text-[15px] text-ivory/75 hover:text-ivory" data-testid={`footer-proj-${p.slug}`}>
                      {p.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-16 flex flex-col gap-3 border-t border-gold/20 pt-6 text-[13px] text-ivory/65 md:flex-row md:justify-between">
        <p>© {new Date().getFullYear()} Little Englishman's Bay Estate</p>
        <p>Some photographs are illustrative.</p>
      </div>
    </div>
  </footer>
);
